// extracted by mini-css-extract-plugin
export default {"sorter":"Sorter_sorter__1AMbG","icon":"Sorter_icon__3nCkS","content":"Sorter_content__2WEAK"};